[
 {
  "id": "pill",
  "x": 223,
  "y": 1111,
  "w": 494,
  "h": 132
 }
]